import {
  FETCH_MARKET_ORDERS,
  FETCH_MARKET_ORDER_DETAIL,
  CREATE_ORDER,
  FETCH_MARKET_ORDER_DUPLICATE,
  FETCH_BACK_ORDER_DETAIL,
  CLEAR_BACK_ORDER_DETAIL,
  CHANGE_ORDER_ITEM_BACK_ORDER,
  CHANGE_ORDER_ITEM_COMPLETED_NOT_BACK_ORDER
} from "./types";
import * as API from "./api";

// --------------------------------------------------------------------------
// FETCH_MARKET_ORDERS
// --------------------------------------------------------------------------
export const fetchOrders = (page, orderId, market, status, date, isPlantUser) => ({
  type: FETCH_MARKET_ORDERS.init,
  payload: API.fetchOrders(page, orderId, market, status, date, isPlantUser),
});

export const fetchOrdersSuccess = (info) => ({
  type: FETCH_MARKET_ORDERS.success,
  payload: info,
});

export const fetchOrdersFailure = (error) => ({
  type: FETCH_MARKET_ORDERS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_MARKET_ORDER_DETAIL
// --------------------------------------------------------------------------
export const fetchOrderDetail = (id) => ({
  type: FETCH_MARKET_ORDER_DETAIL.init,
  payload: API.fetchOrderDetail(id),
});

export const fetchOrderDetailSuccess = (info) => ({
  type: FETCH_MARKET_ORDER_DETAIL.success,
  payload: info,
});

export const fetchOrderDetailFailure = (error) => ({
  type: FETCH_MARKET_ORDER_DETAIL.failure,
  payload: error,
});

// ---------------------------------------------------------------------------
// CREATE_ORDER
// ---------------------------------------------------------------------------
export const createOrder = () => ({
  type: CREATE_ORDER.init,
  payload: API.createOrder(),
});

export const createOrderSuccess = (info) => ({
  type: CREATE_ORDER.success,
  payload: info,
});

export const createOrderFailure = (error) => ({
  type: CREATE_ORDER.failure,
  payload: error,
});

// ---------------------------------------------------------------------------
// FETCH_MARKET_ORDER_DUPLICATE
// ---------------------------------------------------------------------------
export const fetchOrderDuplicate = (id) => ({
  type: FETCH_MARKET_ORDER_DUPLICATE.init,
  payload: API.fetchOrderDuplicate(id),
});

export const fetchOrderDuplicateSuccess = (info) => ({
  type: FETCH_MARKET_ORDER_DUPLICATE.success,
  payload: info,
});

export const fetchOrderDuplicateFailure = (error) => ({
  type: FETCH_MARKET_ORDER_DUPLICATE.failure,
  payload: error,
});

// ---------------------------------------------------------------------------
// FETCH_BACK_ORDER_DETAIL
// ---------------------------------------------------------------------------
export const fetchBackOrderDetail = (id) => ({
  type: FETCH_BACK_ORDER_DETAIL.init,
  payload: API.fetchBackOrderDetail(id),
  orderId: id,
});

export const fetchBackOrderDetailSuccess = (info) => ({
  type: FETCH_BACK_ORDER_DETAIL.success,
  payload: info,
});

export const fetchBackOrderDetailFailure = (error) => ({
  type: FETCH_BACK_ORDER_DETAIL.failure,
  payload: error,
});

// ---------------------------------------------------------------------------
// CLEAR_BACK_ORDER_DETAIL
// ---------------------------------------------------------------------------
export const clearBackOrderDetail = () => ({
  type: CLEAR_BACK_ORDER_DETAIL,
});

// ---------------------------------------------------------------------------
// CHANGE_ORDER_ITEM_BACK_ORDER
// ---------------------------------------------------------------------------
export const changeOrderItemBackOrder = (orderItemId, value) => ({
  type: CHANGE_ORDER_ITEM_BACK_ORDER,
  payload: {
    orderItemId,
    value,
  },
});

// ---------------------------------------------------------------------------
// CHANGE_ORDER_ITEM_COMPLETED_NOT_BACK_ORDER
// ---------------------------------------------------------------------------
export const changeOrderItemCompletedNotBackOrder = (orderItemId, value) => ({
  type: CHANGE_ORDER_ITEM_COMPLETED_NOT_BACK_ORDER,
  payload: {
    orderItemId,
    value
  },
});
